import { toast } from 'sonner'

export interface ToastMessage {
  severity?: 'success' | 'info' | 'warn' | 'error'
  summary?: string
  detail?: string
  life?: number
}

export const isInsufficientPermissionsError = (error: unknown) =>
  (error as { response?: { data?: { code?: string } } })?.response?.data?.code ===
  'INSUFFICIENT_PERMISSIONS'

/**
 * Same as showToast, but skips showing anything for an INSUFFICIENT_PERMISSIONS error —
 * the global API interceptor in API.service.ts already shows a toast for that case,
 * so callers using this avoid double-toasting a permission-denied request.
 */
export const showErrorToastUnlessPermissionDenied = (error: unknown, message: ToastMessage) => {
  if (isInsufficientPermissionsError(error)) {
    return
  }
  showToast(message)
}

export const showToast = (message: ToastMessage) => {
  const title = message.summary
  const description = message.detail

  switch (message.severity) {
    case 'error':
    case 'warn':
      toast.error(title ?? 'Hoppla! Es ist ein Fehler aufgetreten.', {
        description:
          description ??
          'Versuch es bitte später erneut, sollte das Problem weiterhin bestehen, wenden dich gerne an uns: hallo@geezee.de',
        duration: message.life,
      })
      break
    case 'success':
      toast.success(title ?? 'Erfolgreich', {
        description: description ?? '',
        duration: message.life,
      })
      break
    case 'info':
      toast.info(title ?? 'Information', {
        description: description ?? '',
        duration: message.life,
      })
      break
    default:
      toast(title ?? '', {
        description: description ?? '',
        duration: message.life,
      })
  }
}
